export const BUSINESS_SELECTION_SLUG = '/business-selection'
export const DASHBOARD_HOME_SLUG = '/dashboard'
export const INDEX_SLUG = '/'
export const LOGIN_SLUG = '/login'
export const CHECKOUT_SLUG = '/checkout'
